import { createContext } from "react";

const DF_LO0008Context = createContext();

export { DF_LO0008Context };
